import { render, staticRenderFns } from "./btnBenefitsContinue.vue?vue&type=template&id=638c9111&scoped=true&"
import script from "./btnBenefitsContinue.vue?vue&type=script&lang=js&"
export * from "./btnBenefitsContinue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638c9111",
  null
  
)

export default component.exports